// frontend/src/pages/Glossary.jsx
import React from "react";
import { motion } from "framer-motion";

export default function Glossary() {
  const glossary = [
    { term: "Blockchain", definition: "A decentralized digital ledger that records transactions across many computers in a way that prevents tampering." },
    { term: "Crypto Wallet", definition: "A software or hardware tool that allows you to store, send, and receive cryptocurrencies." },
    { term: "Private Key", definition: "A secret code used to access your crypto funds. If you lose it, you lose access to your assets." },
    { term: "Public Address", definition: "A shareable wallet address used to receive crypto, similar to a bank account number." },
    { term: "Stablecoin", definition: "A cryptocurrency pegged to a stable asset like USD or INR, such as USDT or USDC." },
    { term: "Gas Fee", definition: "The transaction cost paid to blockchain validators, especially on Ethereum and similar chains." },
    { term: "Spot Market", definition: "A market where assets are bought and sold for immediate delivery at current prices." },
    { term: "Futures Market", definition: "A market where participants trade contracts that speculate on future prices of assets." },
    { term: "KYC (Know Your Customer)", definition: "A compliance process requiring users to verify their identity before using crypto platforms." },
    { term: "TDS (Tax Deducted at Source)", definition: "In India, 1% tax deducted on crypto sell trades, automatically handled by platforms like Coinzetto." },
    { term: "Market Order", definition: "An order to buy or sell immediately at the best available current price." },
    { term: "Limit Order", definition: "An order to buy or sell at a specific price or better, which executes only when that price is met." },
  ];

  return (
    <motion.div
      className="min-h-screen bg-blue-50 text-slate-800 dark:bg-slate-900 dark:text-slate-100 pb-12 md:pb-16"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Hero */}
      <header className="bg-white/90 dark:bg-slate-900/90 backdrop-blur shadow-md border-b-4 border-blue-600 dark:border-blue-500">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10 md:py-16 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-800 dark:text-blue-300 mb-3 md:mb-4">
            Crypto Glossary
          </h1>
          <p className="text-blue-700/90 dark:text-blue-200/90 text-sm sm:text-lg md:text-xl max-w-2xl mx-auto">
            Understand common terms used in trading, blockchain, and the crypto economy.
          </p>
        </div>
      </header>

      {/* Glossary List */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 mt-10 md:mt-16 space-y-4 sm:space-y-6">
        {glossary.map((item, index) => (
          <motion.div
            key={index}
            whileHover={{ y: -2 }}
            transition={{ type: "spring", stiffness: 250, damping: 20 }}
            className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-4 sm:p-6 shadow-sm"
          >
            <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-blue-800 dark:text-blue-300">
              {item.term}
            </h2>
            <p className="text-sm sm:text-base text-slate-700 dark:text-slate-300 mt-1.5">
              {item.definition}
            </p>
          </motion.div>
        ))}
      </main>

      {/* CTA */}
      <section className="text-center pt-10 md:pt-16">
        <h2 className="text-2xl sm:text-3xl font-semibold text-blue-800 dark:text-blue-300 mb-2 md:mb-4">
          Continue Learning
        </h2>
        <p className="text-sm sm:text-base text-slate-700 dark:text-slate-300 mb-4 md:mb-6">
          Head to our{" "}
          <a href="/learn" className="text-blue-600 dark:text-blue-400 underline underline-offset-4 hover:no-underline">
            Learn
          </a>{" "}
          section for videos, tutorials, and more.
        </p>
        <a
          href="/signup"
          className="inline-flex items-center justify-center rounded-xl px-5 py-2.5 sm:px-8 sm:py-3 text-sm sm:text-base font-medium bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 dark:focus-visible:ring-blue-500 shadow"
        >
          Get Started with Coinzetto
        </a>
      </section>
    </motion.div>
  );
}
